/* OJW Monthly Promo Page — set builder (Bundle mode). Pitch Pulse app extension, Oct 2026.
   Reads the JSON config the section prints, renders the step builder + sticky tracker,
   and adds the finished set to the cart as separate line items via /cart/add.js,
   so the store's own discount applies. Steps come from section blocks, so any promo
   shape works (hoodie + 1 shirt, hoodie + pants + 2 shirts, ...). No dependencies. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, params) {
    params = params || {};
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) { /* tracking must never break the page */ }
  }
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function sizeMain(z) { return String(z).replace(/\s*\(.*\)\s*$/, ''); }
  function sizeSub(z) { var m = String(z).match(/\(([^)]*)\)\s*$/); return m ? m[1] : ''; }
  function shortName(t) {
    return String(t).replace(/\s*\|.*$/, '').replace(/ (Oversized )?(Hoodie|Tee|T-Shirt|Shirt|Pants)$/i, '');
  }
  /* "2 shirts" -> "Shirts", "1 shirt" -> "Shirt", "Hoodie" -> "Hoodie" */
  function unitLabel(s) {
    var l = String(s.label || '').replace(/^\d+\s*/, '');
    return l.charAt(0).toUpperCase() + l.slice(1);
  }

  function init(root) {
    if (root.__ojwReady) return;
    root.__ojwReady = true;
    var cfgEl = root.querySelector('[data-ojw-pb-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[OJW promo] config is not valid JSON', e); return; }

    var steps = (cfg.steps || []).filter(Boolean);
    steps.forEach(function (s) {
      s.products = (s.products || []).filter(Boolean);
      s.products.forEach(function (p, i) {
        p.variants = (p.variants || []).filter(Boolean);
        p.images = (p.images || []).filter(Boolean);
        p.rank = i;
        p.soldOut = !p.variants.some(function (v) { return v.available; });
      });
    });
    var sets = (cfg.sets || []).filter(Boolean).map(function (st) { st.ids = (st.ids || []).filter(Boolean); return st; });
    if (!steps.length) return;

    var prefix = cfg.currencyPrefix || '$';
    var money = function (cents) { return prefix + (cents / 100).toFixed(2); };
    var INITIAL = cfg.initialCount || 8;

    var state = { step: 0, open: null, slots: {}, filter: {}, showAll: {}, busy: false, note: '' };
    steps.forEach(function (s) { state.slots[s.key] = new Array(s.slots).fill(null); });

    var $ = function (sel) { return root.querySelector(sel); };
    var live = function (t) { var el = $('[data-live]'); if (el) el.textContent = t; };
    var findProduct = function (step, pid) { return step.products.filter(function (p) { return p.id === pid; })[0]; };
    var stepDone = function (s) { return state.slots[s.key].every(function (x) { return x && x.vid; }); };
    var firstOpen = function () { for (var i = 0; i < steps.length; i++) if (!stepDone(steps[i])) return i; return -1; };
    var complete = function () { return firstOpen() === -1; };
    var filled = function (s) { return state.slots[s.key].filter(function (x) { return x && x.vid; }).length; };

    function renderSteps() {
      $('[data-steps]').innerHTML = steps.map(function (s, i) {
        var sl = state.slots[s.key], done = stepDone(s);
        var sub = done ? (s.slots === 1 ? esc(sizeMain(sl[0].size) + ' · ' + shortName(findProduct(s, sl[0].pid).title)) : 'All picked')
          : (s.slots > 1 ? filled(s) + ' of ' + s.slots + ' picked' : 'Not picked');
        return '<button type="button" class="ojw-pb__step' + (done ? ' is-done' : '') + '" data-step="' + i + '"' + (state.step === i ? ' aria-current="step"' : '') + '>' +
          '<span class="ojw-pb__step-n">' + (done ? '✓ Done' : 'Step ' + (i + 1)) + '</span><span class="ojw-pb__step-t">' + esc(s.label) + '</span><span class="ojw-pb__step-s">' + sub + '</span></button>';
      }).join('');
    }

    function renderPanel() {
      var s = steps[state.step], sl = state.slots[s.key];
      var slotHtml = sl.map(function (x, i) {
        var lab = s.slots > 1 ? esc(unitLabel(s)) + ' ' + (i + 1) + ': ' : '';
        if (!x) return '<span class="ojw-pb__slot is-empty">' + lab + 'not picked</span>';
        var p = findProduct(s, x.pid);
        return '<span class="ojw-pb__slot' + (x.vid ? '' : ' is-need') + '">' + lab + esc(shortName(p.title)) + ' · ' + esc(x.size ? sizeMain(x.size) : 'pick size') +
          '<button type="button" data-remove="' + i + '" aria-label="Remove ' + esc(p.title) + '">×</button></span>';
      }).join('');

      var f = state.filter[s.key] || 'All';
      var list = s.products.filter(function (p) { return f === 'All' || p.series === f; }).sort(function (a, b) {
        return ((b.pinned ? 1 : 0) - (a.pinned ? 1 : 0)) || ((a.soldOut ? 1 : 0) - (b.soldOut ? 1 : 0)) || (a.rank - b.rank);
      });
      var expanded = state.showAll[s.key] || f !== 'All';
      var shown = expanded ? list : list.slice(0, INITIAL);
      list.forEach(function (p) {
        if (shown.indexOf(p) < 0 && (p.id === state.open || sl.some(function (x) { return x && x.pid === p.id; }))) shown = shown.concat(p);
      });
      var hidden = list.length - shown.length;

      var chips = '';
      if (s.chips) {
        var series = ['All'];
        s.products.forEach(function (p) { if (p.series && series.indexOf(p.series) < 0) series.push(p.series); });
        if (series.length > 2) {
          chips = '<div class="ojw-pb__filters" role="group" aria-label="Filter by series">' + series.map(function (x) {
            var n = x === 'All' ? s.products.length : s.products.filter(function (p) { return p.series === x; }).length;
            return '<button type="button" class="ojw-pb__fchip' + (x === f ? ' is-on' : '') + '" data-filter="' + esc(x) + '" aria-pressed="' + (x === f) + '">' + esc(x) + ' <span>' + n + '</span></button>';
          }).join('') + '</div>';
        }
      }

      var cards = shown.map(function (p) {
        var img = p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="480" height="600">' : '';
        var badge = p.badge ? '<span class="ojw-pb__badge">' + esc(p.badge) + '</span>' : '';
        if (p.soldOut) {
          return '<div class="ojw-pb__card is-soldout"><button type="button" class="ojw-pb__pick" disabled aria-label="' + esc(p.title) + ', sold out"><div class="ojw-pb__img">' + img + '</div><div class="ojw-pb__info"><span class="ojw-pb__name">' + esc(p.title) + '</span><span class="ojw-pb__price">Sold out</span></div></button></div>';
        }
        var picked = sl.filter(function (x) { return x && x.pid === p.id && x.vid; }).map(function (x) { return x.size; });
        var price = s.free ? '<span class="ojw-pb__was">' + money(p.price) + '</span><span class="ojw-pb__free">FREE</span>' : money(p.price);
        /* keep hyphenated words like "fan-voted" on one line */
        var ribbon = p.pinned && s.pinLabel ? '<span class="ojw-pb__ribbon">' + String(s.pinLabel).replace(/ ([·|•–—]) /g, '\u00a0$1 ').split(' ').map(function (w) { return w.indexOf('-') > -1 ? '<span class="ojw-pb__nowrap">' + esc(w) + '</span>' : esc(w); }).join(' ') + '</span>' : '';
        var flags = ribbon || badge ? '<div class="ojw-pb__flags">' + ribbon + badge + '</div>' : '';
        var tick = picked.length ? '<span class="ojw-pb__tick">✓ ' + esc(picked.map(sizeMain).join(', ')) + '</span>' : '';
        var foot = picked.length ? '<div class="ojw-pb__card-foot"><span class="ojw-pb__in-set">✓ In your set · ' + esc(picked.map(sizeMain).join(', ')) + '</span>' +
          '<button type="button" class="ojw-pb__remove" data-remove-pid="' + p.id + '" aria-label="Remove ' + esc(p.title) + ' from your set">Remove</button></div>' : '';
        return '<div class="ojw-pb__card' + (ribbon ? ' is-pinned' : '') + (picked.length ? ' is-chosen' : '') + '"><button type="button" class="ojw-pb__pick" data-open="' + p.id + '" aria-haspopup="dialog"><div class="ojw-pb__img">' + img + flags + tick + '</div><div class="ojw-pb__info"><span class="ojw-pb__name">' + esc(p.title) + '</span><span class="ojw-pb__price">' + price + '</span>' + (picked.length ? '<span class="ojw-pb__cta ojw-pb__cta--muted">Change size</span>' : '<span class="ojw-pb__cta">Choose size</span>') + '</div></button>' + foot + '</div>';
      }).join('');

      var more = hidden > 0 ? '<button type="button" class="ojw-pb__more" data-showall="1">Show all ' + list.length + ' ' + esc(s.noun) + '</button>'
        : (state.showAll[s.key] && f === 'All' && list.length > INITIAL ? '<button type="button" class="ojw-pb__more" data-showless="1">Show fewer</button>' : '');

      $('[data-panel]').innerHTML = '<div class="ojw-pb__panel-head"><h3>' + esc(s.title) + '</h3>' + (state.step > 0 ? '<button type="button" class="ojw-pb__back" data-step="' + (state.step - 1) + '">← Back</button>' : '') + '</div>' +
        chips + (s.products.length ? '<div class="ojw-pb__grid">' + cards + '</div>' + more : '<p class="ojw-pb__empty">No products in this step yet. Check that the step has a collection with products in it.</p>');
    }

    function renderSummary() {
      var box = root.querySelector('[data-summary]'); if (!box) return;
      var value = 0, free = 0, rows = '';
      steps.forEach(function (s, si) {
        state.slots[s.key].forEach(function (x, i) {
          var lab = s.slots > 1 ? unitLabel(s) + ' ' + (i + 1) : unitLabel(s);
          if (x && x.vid) {
            var p = findProduct(s, x.pid), im = (p.images && p.images[0]) || p.image;
            value += p.price; if (s.free) free += p.price;
            rows += '<div class="ojw-pb__sum-row"><button type="button" class="ojw-pb__sum-main" data-step="' + si + '" data-jump="1">' +
              '<span class="ojw-pb__sum-img">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="ojw-pb__sum-txt"><span class="ojw-pb__sum-lab">' + esc(lab) + '</span><span class="ojw-pb__sum-name">' + esc(shortName(p.title)) + '</span><span class="ojw-pb__sum-size">Size ' + esc(sizeMain(x.size)) + '</span></span>' +
              '<span class="ojw-pb__sum-price">' + (s.free ? '<s>' + money(p.price) + '</s><b class="ojw-pb__free">FREE</b>' : money(p.price)) + '</span></button>' +
              '<button type="button" class="ojw-pb__sum-x" data-remove-slot="' + si + ':' + i + '" aria-label="Remove ' + esc(p.title) + '">×</button></div>';
          } else {
            rows += '<div class="ojw-pb__sum-row is-empty"><button type="button" class="ojw-pb__sum-main" data-step="' + si + '" data-jump="1">' +
              '<span class="ojw-pb__sum-img"></span><span class="ojw-pb__sum-txt"><span class="ojw-pb__sum-lab">' + esc(lab) + '</span><span class="ojw-pb__sum-name">' + (x ? 'Pick a size' : 'Not picked yet') + '</span></span>' +
              '<span class="ojw-pb__sum-price">' + (s.free ? '<b class="ojw-pb__free">FREE</b>' : '') + '</span></button></div>';
          }
        });
      });
      box.innerHTML = '<div class="ojw-pb__sum-list">' + rows + '</div>' +
        '<div class="ojw-pb__sum-totals">' +
          (free ? '<div><span>Value</span><span>' + money(value) + '</span></div><div class="is-save"><span>You save</span><span>−' + money(free) + '</span></div>' : '') +
          '<div class="is-total"><span>You pay</span><span>' + money(value - free) + '</span></div>' +
        '</div>';
    }

    function renderTracker() {
      $('[data-chips]').innerHTML = steps.map(function (s, i) {
        var ok = stepDone(s), cur = state.step === i;
        var lab = s.slots > 1 ? esc(unitLabel(s)) + ' ' + filled(s) + '/' + s.slots : esc(unitLabel(s));
        return '<button type="button" class="ojw-pb__chip' + (ok ? ' is-ok' : '') + (cur ? ' is-cur' : '') + '" data-step="' + i + '" data-jump="1"' + (cur ? ' aria-current="step"' : '') + ' aria-label="Go to ' + esc(s.label) + ' step">' + (ok ? '✓ ' : '○ ') + lab + '</button>';
      }).join('');
      var pay = 0;
      steps.forEach(function (s) {
        if (s.free) return;
        state.slots[s.key].forEach(function (x) { if (x && x.vid) pay += findProduct(s, x.pid).price; });
      });
      var freeStep = steps.filter(function (s) { return s.free; })[0];
      $('[data-save]').innerHTML = complete() ? 'You pay <b>' + money(pay) + '</b>' : (freeStep ? 'Free: <b>' + filled(freeStep) + '/' + freeStep.slots + '</b>' : '');
      renderSummary();
      var b = $('[data-tracker-btn]');
      if (state.busy) { b.textContent = 'Adding…'; b.disabled = true; return; }
      b.disabled = false;
      if (complete()) {
        b.className = 'ojw-pb__btn ojw-pb__btn--accent';
        b.textContent = 'Add set to cart' + (cfg.freeValueText ? ' · save ' + cfg.freeValueText : '');
      } else {
        var i = firstOpen(), s = steps[i], left = s.slots - filled(s);
        b.className = 'ojw-pb__btn ojw-pb__btn--light';
        b.textContent = s.slots > 1 && left < s.slots ? 'Next: pick ' + left + ' more' : 'Next: ' + s.title.charAt(0).toLowerCase() + s.title.slice(1);
      }
    }

    /* Size sheet: tapping a product slides a panel up from the bottom with its sizes.
       The grid never moves, and the sizes sit right under the thumb. */
    var lastFocus = null;
    function renderSheet() {
      var host = root.querySelector('[data-sheet]');
      if (!host) { host = document.createElement('div'); host.setAttribute('data-sheet', ''); root.appendChild(host); }
      var s = steps[state.step], p = state.open ? findProduct(s, state.open) : null;
      if (!p) {
        if (host.innerHTML) {
          host.innerHTML = ''; host.removeAttribute('data-key');
          document.documentElement.classList.remove('ojw-pb-lock');
          if (lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
        }
        return;
      }
      var sl = state.slots[s.key];
      var picked = sl.filter(function (x) { return x && x.pid === p.id && x.vid; }).map(function (x) { return x.vid; });
      /* the size the shopper has tapped but not yet added (pre-selects their current size when editing) */
      if (!state.pending || state.pending.pid !== p.id) {
        var cur = s.slots === 1 ? sl.filter(function (x) { return x && x.pid === p.id && x.vid; })[0] : null;
        state.pending = { pid: p.id, vid: cur ? cur.vid : null, size: cur ? cur.size : null };
      }
      var pend = state.pending;
      var key = p.id + '|' + state.note + '|' + picked.join(',') + '|' + pend.vid;
      if (host.getAttribute('data-key') === key) return;
      var fresh = !host.innerHTML;
      host.setAttribute('data-key', key);
      var filledN = filled(s), slotHint = s.slots > 1 ? ' · ' + unitLabel(s) + ' ' + Math.min(filledN + 1, s.slots) + ' of ' + s.slots : '';
      var imgs = galleryOf(p);
      var price = s.free ? '<span class="ojw-pb__was">' + money(p.price) + '</span><span class="ojw-pb__free">FREE</span>' : money(p.price);
      var oldGallery = host.querySelector('[data-gallery]'), keepScroll = oldGallery && !fresh ? oldGallery.scrollLeft : 0;
      var gallery = imgs.length ? '<div class="ojw-pb__gwrap"><div class="ojw-pb__gallery" data-gallery>' +
          imgs.map(function (u, i) { return '<button type="button" class="ojw-pb__gslide" data-zoom="' + i + '" aria-label="Zoom photo ' + (i + 1) + ' of ' + imgs.length + '"><img src="' + esc(u) + '" alt="" loading="' + (i ? 'lazy' : 'eager') + '"></button>'; }).join('') +
          '</div><span class="ojw-pb__zhint" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M11 8v6M8 11h6"/></svg>Tap to zoom</span>' +
          (imgs.length > 1 ? '<div class="ojw-pb__dots" data-dots>' + imgs.map(function (u, i) { return '<span' + (i ? '' : ' class="is-on"') + '></span>'; }).join('') + '</div>' : '') +
        '</div>' : '';
      host.innerHTML = '<div class="ojw-pb__scrim" data-sheet-close="1"></div>' +
        '<div class="ojw-pb__sheet' + (fresh ? ' is-new' : '') + '" role="dialog" aria-modal="true" aria-labelledby="ojw-sheet-title">' +
          '<button type="button" class="ojw-pb__sheet-x" data-sheet-close="1" aria-label="Close">×</button>' +
          gallery +
          '<div class="ojw-pb__sheet-info"><p class="ojw-pb__sheet-step">' + esc(s.label) + esc(slotHint) + '</p><h3 id="ojw-sheet-title">' + esc(p.title) + '</h3><p class="ojw-pb__price">' + price + '</p>' +
            '<a href="' + esc(p.url) + '" target="_blank" rel="noopener">Details &amp; size guide</a></div>' +
          '<p class="ojw-pb__sheet-label">Pick your size</p>' +
          '<div class="ojw-pb__sizes" role="group" aria-label="' + esc(p.title) + ' sizes">' +
            p.variants.map(function (v) {
              var on = pend.vid === v.id, sub = sizeSub(v.size);
              return '<button type="button" class="ojw-pb__size' + (on ? ' is-on' : '') + '" data-sel-vid="' + v.id + '" data-size="' + esc(v.size) + '"' + (v.available ? '' : ' disabled aria-label="' + esc(v.size) + ', sold out"') + ' aria-pressed="' + on + '">' + esc(sizeMain(v.size)) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</button>';
            }).join('') + '</div>' +
          (state.note ? '<p class="ojw-pb__note">' + esc(state.note) + '</p>' : '') +
          '<div class="ojw-pb__sheet-cta">' + addButton(s, p, pend, picked) + '</div>' +
        '</div>';
      document.documentElement.classList.add('ojw-pb-lock');
      var g = host.querySelector('[data-gallery]'), dots = host.querySelector('[data-dots]');
      if (g) {
        if (keepScroll) g.scrollLeft = keepScroll;
        if (dots) g.addEventListener('scroll', function () {
          var i = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
          Array.prototype.forEach.call(dots.children, function (d, k) { d.className = k === i ? 'is-on' : ''; });
        }, { passive: true });
      }
      if (fresh) {
        var first = host.querySelector('.ojw-pb__size:not(:disabled)');
        if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 60);
      }
    }
    function addButton(s, p, pend, picked) {
      if (!pend.vid) return '<button type="button" class="ojw-pb__btn ojw-pb__btn--light ojw-pb__btn--wait" data-sheet-add="1">Select a size</button>';
      var size = sizeMain(pend.size);
      var addLabel = (s.free ? 'Add free ' + (p.title.match(/tee|shirt/i) ? 'shirt' : 'item') : 'Add to set') + ' · Size ' + size;
      var label = s.slots === 1 && picked.indexOf(pend.vid) > -1 ? 'Keep size ' + size : (s.slots === 1 && picked.length ? 'Change to size ' + size : addLabel);
      return '<button type="button" class="ojw-pb__btn ojw-pb__btn--accent" data-sheet-add="1">' + esc(label) + '</button>';
    }
    function confirmAdd() {
      var pend = state.pending;
      if (!pend || !pend.vid) { state.note = 'Pick your size first.'; renderSheet(); return; }
      state.pending = null;
      pickSize(pend.pid, pend.vid, pend.size);
    }
    function closeSheet() { state.open = null; state.note = ''; state.zoom = null; state.pending = null; render(); }

    /* Full-screen photo zoom. Tap the photo to zoom in on that spot, tap again to zoom out.
       Arrows (or swipe the strip in the sheet) to change photo. */
    function galleryOf(p) { return p.images && p.images.length ? p.images : (p.image ? [p.image] : []); }
    function bigUrl(u) { return String(u).replace(/([?&]width=)\d+/, '$11800'); }
    function renderZoom() {
      var host = root.querySelector('[data-zoombox]');
      if (!host) { host = document.createElement('div'); host.setAttribute('data-zoombox', ''); root.appendChild(host); }
      var z = state.zoom;
      if (!z) { host.innerHTML = ''; return; }
      var many = z.imgs.length > 1;
      host.innerHTML = '<div class="ojw-pb__zoom" role="dialog" aria-modal="true" aria-label="Photo ' + (z.i + 1) + ' of ' + z.imgs.length + '">' +
        '<div class="ojw-pb__zoom-bar"><span>' + (many ? (z.i + 1) + ' / ' + z.imgs.length : '') + '</span><span class="ojw-pb__zoom-tip">Tap photo to zoom</span><button type="button" class="ojw-pb__zoom-x" data-zoom-close="1" aria-label="Close photo">×</button></div>' +
        '<div class="ojw-pb__zoom-stage" data-zstage><img class="ojw-pb__zimg" src="' + esc(bigUrl(z.imgs[z.i])) + '" alt=""></div>' +
        (many ? '<button type="button" class="ojw-pb__znav ojw-pb__znav--prev" data-zoom-nav="-1" aria-label="Previous photo">‹</button><button type="button" class="ojw-pb__znav ojw-pb__znav--next" data-zoom-nav="1" aria-label="Next photo">›</button>' : '') +
      '</div>';
      var x = host.querySelector('[data-zoom-close]'); if (x) { try { x.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
    function toggleZoom(img, ev) {
      var stage = img.parentNode, r = img.getBoundingClientRect();
      var fx = r.width ? (ev.clientX - r.left) / r.width : .5, fy = r.height ? (ev.clientY - r.top) / r.height : .5;
      var on = !stage.classList.contains('is-zoomed');
      if (on) {
        /* zoom relative to the photo as it fits the screen, so phone and desktop feel the same */
        var factor = Math.min(4, Math.max(1.2, Number(cfg.zoomLevel) || 2));
        img.style.width = Math.round(img.offsetWidth * factor) + 'px';
      } else {
        img.style.width = '';
      }
      stage.classList.toggle('is-zoomed', on);
      var tip = root.querySelector('.ojw-pb__zoom-tip'); if (tip) tip.textContent = on ? 'Tap to zoom out' : 'Tap photo to zoom';
      if (on) {
        stage.scrollLeft = Math.max(0, fx * img.offsetWidth - stage.clientWidth / 2);
        stage.scrollTop = Math.max(0, fy * img.offsetHeight - stage.clientHeight / 2);
      }
    }

    function render() { renderSteps(); renderPanel(); renderTracker(); renderSheet(); renderZoom(); }

    function goStep(i, scroll) {
      state.step = i; state.note = '';
      var need = state.slots[steps[i].key].filter(function (x) { return x && !x.vid; })[0];
      state.open = need ? need.pid : null;
      render();
      if (scroll) document.getElementById('ojw-build').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function pickSize(pid, vid, size) {
      var s = steps[state.step], sl = state.slots[s.key];
      state.note = '';
      var i = sl.findIndex(function (x) { return x && x.pid === pid && !x.vid; });
      if (i < 0) i = sl.findIndex(function (x) { return !x; });
      if (i < 0) {
        if (s.slots === 1) i = 0;
        else { state.note = 'You\'ve picked all ' + s.slots + '. Remove one from the grid to swap it.'; render(); return; }
      }
      sl[i] = { pid: pid, vid: vid, size: size };
      live(findProduct(s, pid).title + ', size ' + size + ' picked');
      if (stepDone(s)) {
        track('promo_step_complete', { step: s.label });
        state.open = null; render();
        var next = firstOpen();
        if (next > -1) setTimeout(function () { goStep(next, true); }, 350);
        else live('Set complete. Add it to your cart.');
      } else {
        var need = sl.filter(function (x) { return x && !x.vid; })[0];
        state.open = need ? need.pid : null;
        render();
      }
    }

    function loadSet(idx) {
      var st = sets[idx]; if (!st) return;
      steps.forEach(function (s) { state.slots[s.key] = new Array(s.slots).fill(null); });
      st.ids.forEach(function (pid) {
        for (var i = 0; i < steps.length; i++) {
          var s = steps[i];
          if (findProduct(s, pid)) {
            var sl = state.slots[s.key], j = sl.findIndex(function (x) { return !x; });
            if (j > -1) { sl[j] = { pid: pid, vid: null, size: null }; break; }
          }
        }
      });
      state.currentSet = st.name;
      track('promo_set_loaded', { set_name: st.name });
      live(st.name + ' loaded. Pick your sizes.');
      goStep(0, true);
    }

    function showError(msg) {
      var el = $('[data-error]');
      el.textContent = msg; el.hidden = !msg;
    }

    /* Debug mode: add ?ojw_debug=1 to the page address to see exactly what is sent to Shopify
       and what Shopify replies, plus a button to try each piece on its own. Visitors never see it. */
    var DEBUG = /[?&]ojw_debug=1/.test(window.location.search);
    var lastItems = [];
    function dbg(title, obj) {
      if (!DEBUG) return;
      var box = root.querySelector('[data-debug]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-debug', '');
        box.className = 'ojw-pb__debug';
        box.innerHTML = '<strong>Debug</strong> <button type="button" data-debug-each="1">Try each piece separately</button> <button type="button" data-debug-clear="1">Clear</button><pre></pre>';
        document.getElementById('ojw-build').appendChild(box);
      }
      box.querySelector('pre').textContent += title + '\n' + (typeof obj === 'string' ? obj : JSON.stringify(obj, null, 1)) + '\n\n';
    }
    function describe(vid) {
      for (var i = 0; i < steps.length; i++) {
        var hit = state.slots[steps[i].key].filter(function (x) { return x && x.vid === vid; })[0];
        if (hit) return findProduct(steps[i], hit.pid).title + ' - ' + hit.size;
      }
      return '';
    }
    function tryEach() {
      var list = lastItems.slice();
      dbg('TRYING EACH PIECE SEPARATELY', 'Note: anything that works is really added to your cart.');
      (function next() {
        var it = list.shift(); if (!it) return;
        fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: it.id, quantity: it.quantity }] })
        }).then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
          .then(function (out) {
            dbg(it.label + ' (variant ' + it.id + ') -> ' + out.status, out.status === 200 ? 'OK, added' : out.body);
            next();
          }).catch(function (e) { dbg(it.label + ' -> network error', String(e)); next(); });
      })();
    }

    function addToCart() {
      var items = {};
      steps.forEach(function (s) { state.slots[s.key].forEach(function (x) { items[x.vid] = (items[x.vid] || 0) + 1; }); });
      var payload = { items: Object.keys(items).map(function (id) { return { id: Number(id), quantity: items[id] }; }) };
      var drawer = document.querySelector('cart-drawer');
      var useDrawer = cfg.afterAdd === 'drawer' && drawer && typeof drawer.renderContents === 'function';
      if (useDrawer) { payload.sections = ['cart-drawer', 'cart-icon-bubble']; payload.sections_url = window.location.pathname; }

      lastItems = payload.items.map(function (it) { return { id: it.id, quantity: it.quantity, label: describe(it.id) }; });
      dbg('SENT to ' + rootUrl() + 'cart/add.js', { page: window.location.href, items: lastItems, sections: payload.sections || null, sections_url: payload.sections_url || null });

      state.busy = true; showError(''); renderTracker();
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (j) { dbg('SHOPIFY REPLIED ' + r.status, r.ok ? { added: (j.items || []).map(function (x) { return x.title + ' x' + x.quantity; }) } : j); if (!r.ok) throw j; return j; });
      }).then(function (res) {
        track('promo_set_add', { set_name: state.currentSet || 'custom', variant_ids: Object.keys(items).join(',') });
        document.dispatchEvent(new CustomEvent('ojw:set-added', { detail: res }));
        steps.forEach(function (s) { state.slots[s.key] = new Array(s.slots).fill(null); });
        state.step = 0; state.open = null; state.busy = false; state.currentSet = null;
        render();
        if (DEBUG) { dbg('DONE', 'Debug mode: staying on this page instead of opening the cart.'); return; }
        if (useDrawer) {
          try {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
            return;
          } catch (e) { /* fall through to the cart page */ }
        }
        window.location.href = rootUrl() + 'cart';
      }).catch(function (err) {
        state.busy = false; renderTracker();
        showError((err && (err.description || err.message)) || 'Something went wrong adding your set. Try again, or add the pieces one by one.');
      });
    }

    document.addEventListener('keydown', function (e) {
      if (state.zoom) {
        if (e.key === 'Escape') { state.zoom = null; renderZoom(); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var z = state.zoom; z.i = (z.i + (e.key === 'ArrowRight' ? 1 : -1) + z.imgs.length) % z.imgs.length; renderZoom(); }
        return;
      }
      if (e.key === 'Escape' && state.open) closeSheet();
    });
    root.addEventListener('click', function (e) {
      var zimg = e.target.closest('.ojw-pb__zimg');
      if (zimg) { toggleZoom(zimg, e); return; }
      if (e.target.closest('[data-zoom-close]')) { state.zoom = null; renderZoom(); return; }
      var zn = e.target.closest('[data-zoom-nav]');
      if (zn) { var z = state.zoom; z.i = (z.i + Number(zn.getAttribute('data-zoom-nav')) + z.imgs.length) % z.imgs.length; renderZoom(); return; }
      var zo = e.target.closest('[data-zoom]');
      if (zo) {
        var sp = findProduct(steps[state.step], state.open);
        if (sp) { state.zoom = { imgs: galleryOf(sp), i: Number(zo.getAttribute('data-zoom')) }; renderZoom(); track('promo_photo_zoom', { product: sp.title }); }
        return;
      }
      if (e.target.closest('[data-sheet-close]')) { closeSheet(); return; }
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      var d = t.dataset;
      if (d.debugEach) { tryEach(); return; }
      if (d.debugClear) { var pre = root.querySelector('[data-debug] pre'); if (pre) pre.textContent = ''; return; }
      if (d.track) { track(d.track, { month: cfg.month || '' }); return; }
      if (d.step !== undefined) { e.preventDefault(); goStep(Number(d.step), !!d.jump); return; }
      if (d.open) { state.note = ''; lastFocus = t; state.open = Number(d.open); render(); return; }
      if (d.selVid) { state.note = ''; state.pending = { pid: state.open, vid: Number(d.selVid), size: d.size }; renderSheet(); return; }
      if (d.sheetAdd) { confirmAdd(); return; }
      if (d.removePid) {
        var rk = steps[state.step].key, rp = Number(d.removePid);
        state.slots[rk] = state.slots[rk].map(function (x) { return x && x.pid === rp ? null : x; });
        state.note = ''; render(); live('Removed from your set'); return;
      }
      if (d.removeSlot) {
        var rs = d.removeSlot.split(':');
        state.slots[steps[Number(rs[0])].key][Number(rs[1])] = null;
        render(); live('Removed from your set'); return;
      }
      if (d.remove !== undefined) { state.slots[steps[state.step].key][Number(d.remove)] = null; state.note = ''; render(); return; }
      if (d.filter) { state.filter[steps[state.step].key] = d.filter; state.open = null; render(); return; }
      if (d.showall) { state.showAll[steps[state.step].key] = true; render(); return; }
      if (d.showless) { state.showAll[steps[state.step].key] = false; render(); document.getElementById('ojw-build').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (d.setIndex !== undefined) { loadSet(Number(d.setIndex)); return; }
      if (t.hasAttribute('data-tracker-btn')) {
        if (state.busy) return;
        if (!complete()) { goStep(firstOpen(), true); return; }
        addToCart();
      }
    });

    /* Countdown: "Goes live …" before the start, "Ends in …" during, "ended" after. */
    function tick() {
      var el = $('[data-timer-text]'); if (!el) return;
      var toMs = function (v) { return typeof v === 'number' ? v : Date.parse(v); };
      var start = toMs(cfg.startsAt), end = toMs(cfg.endsAt), now = Date.now();
      if (isNaN(end)) return;
      if (!isNaN(start) && now < start) { el.textContent = 'Goes live ' + new Date(start).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }); return; }
      if (now > end) { el.textContent = 'This deal has ended'; return; }
      var ms = end - now, dd = Math.floor(ms / 864e5), hh = Math.floor(ms % 864e5 / 36e5), mm = Math.floor(ms % 36e5 / 6e4);
      el.textContent = 'Ends in ' + dd + 'd ' + hh + 'h ' + mm + 'm';
    }
    (function desktopLayout() {
      var tracker = root.querySelector('.ojw-pb__tracker'), aside = root.querySelector('[data-aside]');
      if (!tracker || !aside || !window.matchMedia) return;
      var home = tracker.parentNode, after = tracker.nextSibling, mq = window.matchMedia('(min-width: 1024px)');
      function place() {
        if (mq.matches) { if (tracker.parentNode !== aside) aside.appendChild(tracker); }
        else if (tracker.parentNode !== home) home.insertBefore(tracker, after);
      }
      place();
      if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
    })();

    /* Hero photo stack: drag the front photo sideways to send it to the back (or click a back photo
       to bring it forward). Desktop only, because the stack is hidden on phones. */
    function deckDrag(box) {
      var cards = Array.prototype.slice.call(box.querySelectorAll('[data-card]'));
      var order = cards.map(function (c, i) { return i; });      /* order[0] = card at the front */
      function layout() {
        order.forEach(function (ci, pos) {
          var c = cards[ci];
          c.className = 'ojw-pb__art-card ojw-pb__art-card--' + pos;
          c.style.transform = '';
        });
      }
      function front() { return cards[order[0]]; }
      var startX = 0, dx = 0, dragging = false, pid = null;
      box.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        var c = e.target.closest('[data-card]'); if (!c) return;
        if (c !== front()) {
          /* click a back card → rotate the whole stack so it comes forward (all cards keep cycling) */
          var pos = order.indexOf(cards.indexOf(c));
          if (pos === 1) order.push(order.shift());               /* left card: same as dragging left */
          else order.unshift(order.pop());                        /* right card: same as dragging right */
          layout(); box.classList.add('was-dragged'); track('promo_hero_drag', {}); return;
        }
        dragging = true; startX = e.clientX; dx = 0; pid = e.pointerId;
        try { box.setPointerCapture(pid); } catch (err) { /* ignore */ }
        box.classList.add('is-dragging');
      });
      box.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pid) return;
        dx = e.clientX - startX;
        front().style.transform = 'translateX(' + dx + 'px) rotate(' + (-1.5 + dx / 18) + 'deg)';
      });
      function end() {
        if (!dragging) return;
        dragging = false; box.classList.remove('is-dragging');
        if (Math.abs(dx) > 70) {
          if (dx < 0) order.push(order.shift());                  /* drag left → front goes to the back */
          else order.unshift(order.pop());                         /* drag right → back card comes forward */
          box.classList.add('was-dragged');
          track('promo_hero_drag', {});
        }
        layout();
      }
      box.addEventListener('pointerup', end);
      box.addEventListener('pointercancel', end);
      box.addEventListener('lostpointercapture', end);
    }

    (function heroArt() {
      var box = root.querySelector('[data-hero-art]'); if (!box) return;
      var picks = [], label = '';
      steps.forEach(function (s) { s.products.forEach(function (p) { if (p.pinned && !p.soldOut) { picks.push(p); if (!label && s.pinLabel) label = s.pinLabel; } }); });
      if (picks.length < 3) steps.forEach(function (s) { s.products.slice(0, 4).forEach(function (p) { if (picks.indexOf(p) < 0 && !p.soldOut) picks.push(p); }); });
      picks = picks.filter(function (p) { return (p.images && p.images[0]) || p.image; }).slice(0, 3);
      if (!picks.length) return;
      box.innerHTML = picks.map(function (p, i) {
        return '<div class="ojw-pb__art-card ojw-pb__art-card--' + i + '" data-card="' + i + '"><img src="' + esc((p.images && p.images[0]) || p.image) + '" alt="" loading="eager" draggable="false"></div>';
      }).join('') + (picks.length > 1 ? '<span class="ojw-pb__art-hint">⟷ Drag to see more</span>' : '');
      if (picks.length > 1) deckDrag(box);
      var banner = typeof cfg.heroArtLabel === 'string' ? cfg.heroArtLabel : 'Latest drop';
      if (banner) box.insertAdjacentHTML('beforeend', '<div class="ojw-pb__art-banner"><span>' + esc(banner) + '</span></div>');
    })();

    tick(); setInterval(tick, 30000);

    render();
  }

  function boot() { document.querySelectorAll('[data-ojw-pb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot); /* theme editor */
})();